import { RepairEstimateRequest } from "@/models/repair-estimate-request.entity";
import repairEstimateRequestService from "@/services/mrfiktiv/services/repair-estimate-request.service";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";

export class RepairEstimateRequestFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.REPAIR_ESTIMATE_REQUEST;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.REPAIR_ESTIMATE_REQUEST, async () => {
      const response = await repairEstimateRequestService.getDocumentBySharedAccessToken(partnerId, refId, sct);
      return new RepairEstimateRequest(response);
    });
  }
}
